import { Injectable } from '@angular/core';
import { MemberEvaluationService } from 'src/app/members/member-evaluation.service';

@Injectable({
  providedIn: 'root'
})
export class PortalEvaluationService extends MemberEvaluationService {
  public get navigationPath(): string {
    return `/portal/forms/evaluation/${this.secureLinkId}`;
  }
}
